import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import CustomizedSteppers from 'components/ui/data-display/RequestStatus';
import SectionTitle from 'components/ui/typography/SectionTitle';
import { IPurchaseRequest } from 'features/inventory/purchase-requests/types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  booleanFilterOperators,
  dateFilterOperators,
  filterOperators
} from 'components/enhanced/data-grid/utils/filters';
import { dateCell, booleanCell } from 'components/cells';

export function PurchaseLineColumns(): GridColDef[] {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const translationPrefix = 'pages.purchase-requests.list';
  const isAdmin = useIsTenantAdministrator();

  const columns: GridColDef[] = [
    {
      field: 'id',
      flex: 0,
      headerName: t('entities.purchase-request.ID'),
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const pr = params.row as IPurchaseRequest;
        const isDisabled = !isAdmin && pr.automatic_generated;

        const linkContent = (
          <SectionTitle>
            {t(`${translationPrefix}.request-description`, { id: pr.id })}
          </SectionTitle>
        );

        if (isDisabled) {
          return (
            <span style={{ color: '#888', cursor: 'not-allowed' }} title="Accesso limitato">
              {linkContent}
            </span>
          );
        }

        return (
          <a
            onClick={() =>
              navigate(`${params.row.automatic_generated ? 'automatic/' : ''}view/${params.row.id}`)
            }
            style={{ cursor: 'pointer' }}>
            {linkContent}
          </a>
        );
      }
    },
    {
      field: 'created_by',
      headerName: t('entities.purchase-request.proposer'),
      filterOperators,
      width: 180,
      flex: 0,
      minWidth: 150
    },
    {
      field: 'created_at',
      width: 150,
      align: 'center',
      flex: 0,
      headerName: t('entities.purchase-request.created_at'),
      headerAlign: 'center',
      filterOperators: dateFilterOperators,
      renderCell: dateCell
    },
    {
      field: 'automatic_generated',
      headerName: t('entities.purchase-request.automatic'),
      type: 'boolean',
      width: 100,
      flex: 0,
      filterable: true,
      filterOperators: booleanFilterOperators,
      renderCell: booleanCell(t)
    },
    {
      field: 'status',
      width: 200,
      flex: 1,
      align: 'center',
      headerAlign: 'center',
      headerName: t('entities.purchase-request.status'),
      filterable: false,
      renderCell: (props: GridRenderCellParams) => {
        const pr = props.row as IPurchaseRequest;
        return (
          <div className="w-full flex flex-row justify-center items-center">
            <div className="w-60">
              <CustomizedSteppers status={pr.status}></CustomizedSteppers>
            </div>
          </div>
        );
      }
    }
  ];
  return columns;
}
